export type HealthHubContactSection = {
  id: string;
  title: string;
  bodyPrefix: string;
  providerLabel: string;
  phone: string;
  phoneHref: string;
  hours?: string;
  email?: string;
  emailHref?: string;
};

export const HEALTH_HUB_CONTACT_SECTIONS: HealthHubContactSection[] = [
  {
    id: 'claims',
    title: 'CLAIMS',
    bodyPrefix:
      'For questions regarding claims and deductible management, call',
    providerLabel: 'Securus:',
    phone: '877-420-0785',
    phoneHref: 'tel:8774200785',
    email: 'customerservice@securusbenefits.com',
    emailHref: 'mailto:customerservice@securusbenefits.com',
  },
  {
    id: 'prescriptions',
    title: 'PRESCRIPTIONS',
    bodyPrefix: 'For questions regarding prescriptions, call',
    providerLabel: 'DisclosedRx Member Services:',
    phone: '888-589-3340',
    phoneHref: 'tel:8885893340',
    email: 'care@disclosedrx.com',
    emailHref: 'mailto:care@disclosedrx.com',
  },
  {
    id: 'telehealth',
    title: 'TELEHEALTH',
    bodyPrefix: 'For questions regarding your Telehealth services, call',
    providerLabel: 'Evo Health:',
    phone: '855-636-3669',
    phoneHref: 'tel:8556363669',
  },
  {
    id: 'general',
    title: 'GENERAL QUESTIONS',
    bodyPrefix:
      'For all other items like enrollment, billing, or general questions, call',
    providerLabel: 'OneHealth Plus Customer Service:',
    phone: '877-881-4584',
    phoneHref: 'tel:8778814584',
    hours: 'Mon-Fri 8am-8pm/EST',
    email: 'support@onehealthplus.com',
    emailHref: 'mailto:support@onehealthplus.com',
  },
];
